import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

//Descarga del CSV de votos. El control es un <button> real (focusable y
//operable con teclado). Antes era un <a> sin href con onClick, que no recibía
//foco ni respondía a Enter/Espacio. La descarga del blob se dispara con un
//ancla creada al vuelo (no queda ningún <a> en el JSX).
const LinkPrivado = (props) => {
  const { usuario, children } = props;
  const [descargando, setDescargando] = useState(false);

  const descarga = async () => {
    if (descargando) return;
    setDescargando(true);
    try {
      //El backend genera el CSV temporal y lo sirve en /api/private; se
      //autodestruye a los ~20 segundos, por eso se pide justo antes de bajarlo.
      await axios.get(`/api/votos/csv/${usuario.municipioId}`);
      const res = await axios.get(
        `/api/private/votacion-${usuario.municipioId}.csv`
      );
      const blob = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
      const href = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = href;
      a.download = `votacion-${usuario.municipioId}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      //Se libera el objeto una vez iniciada la descarga.
      setTimeout(() => window.URL.revokeObjectURL(href), 1000);
    } catch (error) {
      Swal.fire(
        "No pudimos descargar los votos",
        "Ocurrió un problema al generar el archivo. Volvé a intentarlo en unos minutos.",
        "error"
      );
    } finally {
      setDescargando(false);
    }
  };

  return (
    <button
      type="button"
      className="btn ppr-btn-azul font-weight-bold m-2 btn-sm"
      onClick={descarga}
      disabled={descargando}
    >
      {descargando ? "Generando archivo..." : children}
    </button>
  );
};

export default LinkPrivado;
